<template>
    <DataLabel
        :item="edition"
        :hide-icon="hideIcon"
        icon-class="far fa-fw fa-file"
        :none="$t( 'editions.nil' )"
        :href="href"
        v-on="$listeners">
        <small v-if="edition && edition.year" class="text-muted">
            {{ edition.year }}
        </small>
    </DataLabel>
</template>

<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'EditionLabel',

    components: {DataLabel},

    props: {
        edition: {type: Object, default: null},
        publication: {type: Object, default: null},
        hideIcon: {type: Boolean},
        showLink: {type: Boolean},
    },

    computed: {
        href() {
            if (!this.edition || !this.publication || !this.showLink) {
                return null;
            }

            if (this.$gate.deny('browse', 'edition', this.publication)) {
                return null;
            }

            if (this.edition.id > 0) {
                return this.$toRoute('publications.editorial.show', {
                    publication: this.publication.id_cpub,
                    edition: this.edition.id,
                }).toString();
            }

            return this.$toRoute('publications.editorial.null', {
                publication: this.publication.id_cpub,
            }).toString();
        },
    },
};
</script>
